'use client';

import { useSearchParams } from 'next/navigation';
import { useCallback, useRef } from 'react';

import { ShopifyQueryParam } from '~/constants/ShopifyQueryParams';

const SHOPIFY_PARAMS = Object.values(ShopifyQueryParam);

export const useWithShopifyParams = () => {
  const searchParams = useSearchParams();

  const withShopifyParams = useCallback(
    (path: string) => {
      const [basePath, existingSearch] = path.split('?');
      const result = new URLSearchParams(existingSearch ?? '');

      for (const key of SHOPIFY_PARAMS) {
        const value = searchParams.get(key);

        if (value) {
          result.set(key, value);
        }
      }

      const search = result.toString();

      return search ? `${basePath}?${search}` : basePath;
    },
    [searchParams],
  );

  const withShopifyParamsRef = useRef(withShopifyParams);
  withShopifyParamsRef.current = withShopifyParams;

  return { withShopifyParams, withShopifyParamsRef };
};
